export default {
    label: {
        fontSize: 16,
        marginBottom: 10,
    },
    error: {
        position: 'absolute',
        color: 'red',
        fontSize: 12,
        bottom: 0,
    },
    input: {
        // width: '45%',
        height: 50,
        paddingHorizontal: 10,
        borderWidth: 1,
        borderColor: 'blue',
        borderRadius: 4,
        fontSize: 16,
    },
    email: {
        // width: '60%',
        height: 50,
        paddingHorizontal: 10,
        borderWidth: 1,
        borderColor: 'blue',
        borderRadius: 4,
        fontSize: 16,
    },
    phoneArea: {
        container: {
            width: '100%',
            borderStyle: 'solid',
            borderColor: 'blue',
        },
        flagContainer: {
            width: 80,
            justifyContent: 'center',
        },
        input: {
            width: '100%',
        },
    },
    imageContent: {
        aspectRatio: 1,
        width: '50%',
        justifyContent: 'center',
    },
    dropdown: {
        height: 50,
        borderWidth: 0.5,
        borderRadius: 8,
        paddingHorizontal: 8,
    },
    icon: {
        marginRight: 5,
    },
    placeholderStyle: {
        fontSize: 16,
    },
    selectedTextStyle: {
        fontSize: 16,
    },
    iconStyle: {
        width: 20,
        height: 20,
    },
    inputSearchStyle: {
        height: 40,
        fontSize: 16,
    },
};
